<template>
    <div class="section-action-number-favourite">
        <div class="section-action-number-favourite__title">
            <ButtonCustom
                type="go-back"
                text="edit Number"
                :isGoBackHistory="false"
                @onClickButton="onClickGoBack"
            />
        </div>

        <FormCommon
            :formItem="formItem"
            :dataForm="dataForm"
            :class-container="'section-action-number-favourite__form'"
            @update-form-data="updateFormData"
            @onSubmitForm="onSubmitForm"
        >
        </FormCommon>

        <QuickPick
            :listNumber="listNumber"
            :numbersChecked="listBlockTickets[0].numbersChecked"
            :indexTicket="0"
            :minimumBalls="minimum"
            :maxiumBlue="maxiumBlue"
            :maxiumGreen="maxiumGreen"
            :showBtnRandom="false"
            class="section-action-number-favourite__quick-pick"
            @handleRandomNumbers="handleRandomNumbers"
            @handlePickNumber="handlePickNumber"
        >
        </QuickPick>

        <div class="section-edit-number">
            <button
                @click="onClickGoBack"
                :disabled="isLoadingButton"
                class="section-edit-number__btn-left t-transform-cap"
            >
                {{ getTranslatedText("cancel") }}
            </button>
            <button
                @click="onSubmitForm"
                :disabled="isLoadingButton"
                class="section-edit-number__btn-right t-transform-cap"
            >
                <b-spinner v-if="isLoadingButton" />
                {{ getTranslatedText("done") }}
            </button>
        </div>
    </div>
</template>
<script>
import FormCommon from "@/components/common/form";
import ButtonCustom from "@/components/common/button";

import quickPickMixin from "@/mixins/quick-pick/quick-pick-mixin";
import LanguageMixin from "@/mixins/language/language-mixin";

import favouriteService from "@/services/favourite.service";
import QuickPick from "@/components/common/quick-pick/QuickPick.vue";

export default {
    mixins: [quickPickMixin, LanguageMixin],
    components: {
        FormCommon,
        ButtonCustom,
        QuickPick,
    },
    props: {
        dataDetail: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            isLoadingButton: false,
            dataForm: {
                name: "",
            },
            formItem: [
                {
                    type: "input",
                    typeInput: "text",
                    placeholder: "name",
                    hideIconRq: true,
                    name: "name",
                    required: true,
                    label: "name",
                    for: "input-name",
                    id: "input-name",
                },
            ],
        };
    },
    created() {
        this.fetchDataDetailNumber();
    },
    methods: {
        fetchDataDetailNumber() {
            this.listBlockTickets[0].numbersChecked = this.dataDetail.balls;
            this.dataForm.name = this.dataDetail.title;
        },

        async onSubmitForm() {
            this.isLoadingButton = true;
            let payload = {
                id: this.dataDetail.id,
                title: this.dataForm.name || "",
                balls: this.listBlockTickets[0].numbersChecked,
            };
            if (payload.balls < this.minimum) {
                this.$emit(
                    "showToast",
                    `${this.getTranslatedText("Please choose at least")} ${
                        this.minimum
                    } ${this.getTranslatedText("numbers")}`,
                    "error"
                );

                this.isLoadingButton = false;
                return false;
            }

            try {
                let param = {
                    id: this.dataDetail.id,
                    favourite_name: payload.title,
                    favourite_number: payload.balls,
                    bonus_ball: [],
                };

                const resp = await favouriteService.update(param);
                if (resp.status === 200) {
                    payload.message =
                        resp?.message || "Favourite number is saved";
                    this.isLoadingButton = false;
                    this.$emit("onSubmit", payload);
                } else {
                    this.isLoadingButton = false;
                    if (resp.errors) {
                        resp.errors.map((message) => {
                            return this.$emit(
                                "showToast",
                                this.getTranslatedText(message.message),
                                "error"
                            );
                        });
                    } else {
                        this.$emit(
                            "showToast",
                            this.getTranslatedText(resp.message),
                            "error"
                        );
                    }
                }
            } catch (err) {
                console.log(err, "err");
            }
        },
        updateFormData(event) {
            let { value } = event;
            this.dataForm.name = value;
        },
        onClickGoBack() {
            this.$emit("onGoBack");
        },
    },
};
</script>

<style
    scoped
    lang="scss"
    src="@/assets/scss/mobile/favourite/_favourite.scss"
/>
